import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';

const Preloader = () => {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      const contentTimer = setTimeout(() => {
        setLoading(false);
      }, 400); // Tiempo de fundid
      return () => clearTimeout(contentTimer);
    }, 1100); // Tiempo de carga de 1600 ms

    return () => clearTimeout(timer);
  }, []);

  return (
    loading ? (
      <Box
        w="100vw"
        h="100vh"
        bg="#ff0000"
        display="flex"
        justifyContent="center"
        alignItems="center"
        position="fixed"
        top="0"
        left="0"
        zIndex="9999"
        opacity={fadeOut ? 0 : 1} // Controla la opacidad para el fundido
        transition="opacity 0.4s ease" // Transición suave de opacidad
      >
        <video
          autoPlay
          muted
          loop
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        >
          <source src="/seiya.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Box>
    ) : null
  );
};

export default Preloader;
